import { api } from "./api";

export async function getDataImport() {
    try {
        const {data} = await api.get('/database/data_import__c');
        return data;
    } catch (error) {
        console.error("erro na busca de dados:", error);
        throw error;
    }

}
